import Vuex from 'vuex'
import headerBar from "./headerBar";

export default (Vue, _theme) => {
    Vue.use(Vuex)
    return  new Vuex.Store({
        state: {
            theme: _theme.getCurTheme() ?? {
                bubbles: ['','',''],
            },
            curRouteName: route().current(),
            titles: headerBar(),
        },
        mutations: {
            'update:theme'(state) {
                let temp = undefined
                temp = _theme.getCurTheme()
                if(temp)
                    state.theme = temp
            },
            'update:route'(state) {
                state.curRouteName = route().current()
            },
            'update:header'(state, page) {
                state.titles = headerBar(!!(page?.auth), page.admin)
            }
        }
    })
}
